import { useState, useRef } from 'react'
import menu1 from '../../../assets/Menu_Backstage.jpg'
import menu2 from '../../../assets/Menu_Back.jpg'

const VIPBarMenu = () => {
  const [current, setCurrent] = useState(0)
  const [animating, setAnimating] = useState(false)
  const [direction, setDirection] = useState(1)
  const containerRef = useRef(null)

  const navigate = (dir) => {
    const next = current + dir
    if (next < 0 || next > 1 || animating) return
    setDirection(dir)
    setAnimating(true)
    setTimeout(() => {
      setCurrent(next)
      setAnimating(false)
    }, 300)
  }

  const images = [menu1, menu2]
  const alts = ['Afrodise Backstage Menu - Drinks & Bottles', 'Afrodise Backstage Menu - Deposit Info']

  const flipStyle = animating
    ? {
        animation: `${direction > 0 ? 'flipForward' : 'flipBack'} 0.5s cubic-bezier(0.4,0,0.2,1) forwards`,
      }
    : {}

  return (
    <div
      style={{
        minHeight: '100vh',
        background: '#1a1208',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '32px 16px',
        boxSizing: 'border-box',
        overflowX: 'hidden',
        flexDirection: 'column',
        gap: '20px',
      }}
    >
      <style>{`
        @keyframes flipForward {
          0%   { transform: rotateY(0deg) scaleX(1); opacity: 1; }
          45%  { transform: rotateY(-90deg) scaleX(0.1); opacity: 0.3; }
          55%  { transform: rotateY(-90deg) scaleX(0.1); opacity: 0.3; }
          100% { transform: rotateY(0deg) scaleX(1); opacity: 1; }
        }
        @keyframes flipBack {
          0%   { transform: rotateY(0deg) scaleX(1); opacity: 1; }
          45%  { transform: rotateY(90deg) scaleX(0.1); opacity: 0.3; }
          55%  { transform: rotateY(90deg) scaleX(0.1); opacity: 0.3; }
          100% { transform: rotateY(0deg) scaleX(1); opacity: 1; }
        }
        .nav-btn {
          position: absolute;
          top: 50%;
          transform: translateY(-50%);
          width: 44px;
          height: 44px;
          border-radius: 50%;
          border: 1.5px solid rgba(196,148,60,0.5);
          background: rgba(26,18,8,0.85);
          color: rgba(196,148,60,0.95);
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          z-index: 2;
          font-size: 22px;
          line-height: 1;
          transition: background 0.2s, border-color 0.2s;
          user-select: none;
          -webkit-tap-highlight-color: transparent;
        }
        .nav-btn:hover {
          background: rgba(196,148,60,0.15);
          border-color: rgba(196,148,60,0.8);
        }
        .nav-btn:active { transform: translateY(-50%) scale(0.92); }
        .nav-btn:disabled {
          opacity: 0.2;
          pointer-events: none;
        }
        .nav-btn.left  { left: -22px; }
        .nav-btn.right { right: -22px; }
        @media (max-width: 480px) {
          .nav-btn.left  { left: 6px; }
          .nav-btn.right { right: 6px; }
        }
      `}</style>

      {/* Ambient glow — warm gold top */}
      <div style={{
        position: 'fixed', top: '-100px', left: '50%',
        transform: 'translateX(-50%)',
        width: '600px', height: '280px',
        background: 'radial-gradient(ellipse at center, rgba(196,148,60,0.15) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />

      {/* Ambient glow — deep amber bottom */}
      <div style={{
        position: 'fixed', bottom: '-80px', left: '50%',
        transform: 'translateX(-50%)',
        width: '500px', height: '220px',
        background: 'radial-gradient(ellipse at center, rgba(160,80,0,0.12) 0%, transparent 70%)',
        pointerEvents: 'none', zIndex: 0,
      }} />

      {/* Page dots */}
      <div style={{ display: 'flex', gap: '10px', zIndex: 1 }}>
        {[0, 1].map((i) => (
          <div
            key={i}
            onClick={() => !animating && i !== current && navigate(i - current)}
            style={{
              width: '8px', height: '8px',
              borderRadius: '50%',
              cursor: i === current ? 'default' : 'pointer',
              background: i === current
                ? 'rgba(196,148,60,0.95)'
                : 'rgba(255,255,255,0.2)',
              transition: 'background 0.3s',
            }}
          />
        ))}
      </div>

      {/* Book stage */}
      <div style={{
        position: 'relative',
        zIndex: 1,
        width: '100%',
        maxWidth: '680px',
      }}>
        <button
          className="nav-btn left"
          onClick={() => navigate(-1)}
          disabled={current === 0 || animating}
          aria-label="Previous page"
        >‹</button>

        <div
          ref={containerRef}
          style={{
            width: '100%',
            transformStyle: 'preserve-3d',
            ...flipStyle,
          }}
        >
          <img
            src={images[current]}
            alt={alts[current]}
            style={{
              width: '100%',
              display: 'block',
              borderRadius: '12px',
              touchAction: 'pinch-zoom',
              boxShadow: '0 8px 40px rgba(0,0,0,0.6)',
            }}
          />
        </div>

        <button
          className="nav-btn right"
          onClick={() => navigate(1)}
          disabled={current === 1 || animating}
          aria-label="Next page"
        >›</button>
      </div>

      {/* Page counter */}
      <div style={{
        color: 'rgba(196,148,60,0.55)',
        fontSize: '12px',
        letterSpacing: '0.14em',
        textTransform: 'uppercase',
        zIndex: 1,
      }}>
        {current + 1} / 2
      </div>
    </div>
  )
}

export default VIPBarMenu;